import { Locale } from "./Api/Types";

// dev or 라이브 인지,

export const IsDevMode = process.env.NODE_ENV === "development" ? true : false;

// 국가, 언어
let COUNTRY = Locale.kokr;
// 국가 언어 저장
export const setLocaleInfo = (val: any) => {
  COUNTRY = val;
};

//국가 언어 리턴
export const getLocaleInfo = () => {
  return COUNTRY;
};

export const API_ROOT_SERVER = () => {
  if (IsDevMode) {
    return "/api";
  } else {
    return "/charlie";
  }
};

export const USER_SERVER = () => {
  if (IsDevMode) {
    return "/api/users";
  } else {
    return "/charlie/users";
  }
};

export const USER_SERVER_NOT_LOGINED = () => {
  if (IsDevMode) {
    return "/api";
  } else {
    return "/charlie";
  }
};
